import { createFileRoute } from "@tanstack/react-router";
import AdminSiteCopy from "@/pages/AdminSiteCopy";

export const Route = createFileRoute("/admin/copy/")({
  component: AdminSiteCopy,
});
